/**
 * Skeleton das campanhas — header + abas + editor de mensagem + lista.
 */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-3xl animate-pulse flex-col gap-6">
      {/* PageHeader */}
      <div className="h-[104px] rounded-[20px] bg-slate-200" />

      {/* Abas */}
      <div className="h-11 rounded-xl bg-slate-100" />

      {/* Editor de mensagem */}
      <div className="h-24 rounded-xl border border-slate-200 bg-white" />

      {/* Lista */}
      <div className="flex flex-col gap-2">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="flex items-center justify-between rounded-xl border border-slate-200 bg-white p-3">
            <div className="space-y-1.5">
              <div className="h-4 w-40 rounded bg-slate-200" />
              <div className="h-3 w-28 rounded bg-slate-100" />
            </div>
            <div className="flex gap-1.5">
              <div className="h-8 w-16 rounded-lg bg-slate-100" />
              <div className="h-8 w-20 rounded-lg bg-slate-100" />
              <div className="h-8 w-8 rounded-lg bg-slate-100" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
